import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  deploymentMode = false;

  constructor(private http: HttpClient) {}

  async loadConfig(): Promise<void> {
    try {
      const config = await this.http.get('/assets/config/config.json')
        .toPromise();
      console.log('[ConfigService] Config loaded:', config);
      this.deploymentMode = config['deploymentMode'] || false;
      console.log('[ConfigService] this.deploymentMode:', this.deploymentMode);
    } catch (err) {
      console.error('[ConfigService] Failed to load config.json:', err);
      this.deploymentMode = false;
    }
  }
}